import * as React from 'react';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { IStore } from 'redux/IStore';
import * as c from 'models/constants';
import { IUserCardData, IUserCardAction } from 'models/user/usercard';
import { IUserPreferences } from 'models/user/userpreferences';
import { IItemCardList } from 'models/itemcard/itemcardlist';
import { ItemCardList } from 'components';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import { getLikes, resetLikesData } from 'modules/user/usercard';
import { getWardrobeItemCard } from 'redux/modules/wardrobe/wardrobeitemcard';
import { getProductCard } from 'redux/modules/product/productcard';
import { getArticleCard } from 'redux/modules/magazine/article/articlecard';
import { getOutfitCard } from 'redux/modules/outfit/outfitcard';
import { IWardrobeItemCardDataAction } from 'models/wardrobe/wardrobeitemcard';
import { IProductCardDataAction } from 'models/product/productcard';
import { IArticleCardAction } from 'models/magazine/article/articlecard';
import { IOutfitCardDataAction } from 'models/outfit/outfitcard';
import { getShopCard } from 'redux/modules/shop/shopcard';

interface IProps {
	userCardData?: IUserCardData;
	userPreferences?: IUserPreferences;
	isMyProfile: boolean;

	/* function props */
	t?: (key: string, options?: any) => string;
	getLikes?: (userId: string, isFirstLoad: boolean) => IUserCardAction;
	resetLikesData?: () => IUserCardAction;
	getWardrobeItemCard?: (id: string, target: string) => IWardrobeItemCardDataAction;
	getProductCard?: (id: string, target: string) => IProductCardDataAction;
	getArticleCard?: (id: string, target: string) => IArticleCardAction;
	getOutfitCard?: (id: string, target: string) => IOutfitCardDataAction;
	getShopCard?: (id: string, target: string) => IOutfitCardDataAction;
}

interface IUserLikesItemCardList extends IItemCardList {
	userPicture?: string;
}

@connect(
	(state: IStore) => ({
		userCardData: state.usercard,
		userPreferences: state.userPreferences,
	}),
	(dispatch) => ({
		getLikes: (userId: string, isFirstLoad: boolean) => dispatch(getLikes(userId, isFirstLoad)),
		resetLikesData: () => dispatch(resetLikesData()),
		getWardrobeItemCard: (id: string, target: string) => dispatch(getWardrobeItemCard(id, target)),
		getProductCard: (id: string, target: string) => dispatch(getProductCard(id, target)),
		getArticleCard: (id: string, target: string) => dispatch(getArticleCard(id, target)),
		getOutfitCard: (id: string, target: string) => dispatch(getOutfitCard(id, target)),
		getShopCard: (id: string, target: string) => dispatch(getShopCard(id, target)),
	}),
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class UserLikes extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.loadMoreData = this.loadMoreData.bind(this);
		this.goToCard = this.goToCard.bind(this);
	}

	public componentWillUnmount() {
		this.props.resetLikesData();
	}

	public loadMoreData() {
		if (this.props.userCardData.selectedTab === c.USERCARD_TAB_LIKES) {
			this.props.getLikes(this.props.userCardData.usercard.id, false);
		}
	}

	private goToCard(id: string, type: string, target: string) {
		switch (type) {
			case c.NODE_TYPE_WARDROBE:
				this.props.getWardrobeItemCard(id, target);
				break;

			case c.NODE_TYPE_PRODUCT:
				this.props.getProductCard(id, target);
				break;

			case c.NODE_TYPE_ARTICLE:
				this.props.getArticleCard(id, target);
				break;

			case c.NODE_TYPE_OUTFIT:
				this.props.getOutfitCard(id, target);
				break;

			case c.NODE_TYPE_SHOP:
				this.props.getShopCard(id, target);
				break;

			default:
				break;
		}
	}

	private getCardTypeByNodeType(type: string) {
		let card = null;
		switch (type) {
			case c.NODE_TYPE_WARDROBE:
				card = c.NODE_TYPE_WARDROBE_ITEM_CARD;
				break;

			case c.NODE_TYPE_PRODUCT:
				card = c.NODE_TYPE_PRODUCT_ITEM_CARD;
				break;

			case c.NODE_TYPE_ARTICLE:
				card = c.NODE_TYPE_ARTICLE_ITEM_CARD;
				break;

			case c.NODE_TYPE_OUTFIT:
				card = c.NODE_TYPE_OUTFIT_ITEM_CARD;
				break;

			default:
				break;
		}
		return card;
	}

	public render() {
		const { t, isMyProfile } = this.props;
		const { picture } = this.props.userCardData.usercard;
		const { likes, likesPage } = this.props.userCardData;

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: likes.length,
			next: this.loadMoreData,
			hasMore: likesPage.totalItems > likes.length,
			loader: <h4>{t('BSPortal_Common_Loading')} </h4>,
		};

		// set type to item
		const likesData = likes.map((item: any) => {
			item.itemType = this.getCardTypeByNodeType(JSON.parse(item.entityId).type);
			return item;
		});

		const listProps: IUserLikesItemCardList = {
			items: likesData,
			itemType: null, // likes can be different types
			isInfiniteScroll: true,
			infiniteScrollProps,
			userPicture: picture,
			isMyProfile,
			goToCard: this.goToCard,
			disableActions: true,
		};

		return (
			<div className="userLikesComponent">
				<div className="userLikesContainer">
					<ItemCardList {...listProps} />
				</div>
			</div>
		);
	}
}

export { UserLikes };
